import { Controller } from "@hotwired/stimulus";
import DOMPurify from "dompurify";

import Swal from "sweetalert2/dist/sweetalert2.js";

export default class extends Controller {
  static targets = ["submit", "close", "enterprise"];

  handleSubmit() {
    setTimeout(() => {
      this.closeTarget.click();
      const selectInputs = document.querySelectorAll(".select-st");
      selectInputs.forEach((select) => {
        this.fetchSousTraitants(select);
      });
    }, 500);
  }

  fetchSousTraitants(selectInput) {
    const enterpriseId = this.enterpriseTarget.value;
    const selectedValue = selectInput.value;
    $.get(`/enterprises/${enterpriseId}/sous_traitants.json`)
      .done((results) => {
        selectInput.innerHTML = results
          .map((result) => {
            return `
          <option value="${DOMPurify.sanitize(result.id)}">${DOMPurify.sanitize(
              result.name
            )}</option>
        `;
          })
          .join("\n");
        if (selectedValue === "") {
          selectInput.selectedIndex = selectInput.options.length - 1;
        } else {
          selectInput.value = selectedValue;
        }
      })
      .fail((err) => console.log(err));
  }
}
